import { render, staticRenderFns } from "./BaseLabelTag.vue?vue&type=template&id=5c6dfc70&scoped=true&"
import script from "./BaseLabelTag.vue?vue&type=script&lang=ts&"
export * from "./BaseLabelTag.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLabelTag.vue?vue&type=style&index=0&id=5c6dfc70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6dfc70",
  null
  
)

export default component.exports